import React, { useEffect } from 'react';
import Model from 'components/Modal';
import { Button, Input } from 'styled';
import axios from 'apis/axios';
import { useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import exportExcel from 'utils/exportExcel';
import { ANALYTICS_EVENTS } from 'utils/analyticsEvents';
import { trackDownloadAndBulkUploadEvents } from 'utils/analytics';
import { useLocation } from 'react-router-dom';


const BulkUpload = ({ handleClick }) => {
  const [file, setFile] = React.useState('');
  const location = useLocation();
  const queryClient = useQueryClient();
  const [correctData, setCorrectData] = React.useState([]);
  const [incorrectData, setIncorrectData] = React.useState([]);

  let downloadSampleExcelLink =
    'https://jk-fleet.s3.ap-south-1.amazonaws.com/sample-bulk-upload.xlsx';


  const vehicleBulkUploadEventFunc = (eventName,module_name,params={}) => {
    return trackDownloadAndBulkUploadEvents(eventName,module_name,location.pathname,params);
  }

  const handleFileChange = async (e) => {
    try {
      e.preventDefault();
      let file = e.target.files[0];
      let allowedFileTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'text/csv',
      ];
      let regEx = new RegExp(
        allowedFileTypes.map((type) => `^.*${type}$`).join('|')
      );
      if (regEx.test(file.type)) {
        setFile(file);
      }
      if (!regEx.test(file.type)) {
        toast.error('please upload only valid excel or csv file');
        //clear file input
        e.target.value = '';
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const handleSubmit = async () => {
    try {
      vehicleBulkUploadEventFunc(ANALYTICS_EVENTS.CLICK_BULK_UPLOAD_BUTTON,"Vehicles",{"model_name":"Bulk Upload Vehicle"})
      let formData = new FormData();
      formData.append('file', file);
      const response = await axios({
        method: 'post',
        url: 'vehicle/bulk',
        data: formData,
      });
      const data = await response.data;
      if(data?.uploadedData){
        vehicleBulkUploadEventFunc(ANALYTICS_EVENTS.SYS_BULK_UPLOAD_VEHICLE_SUCCESS,"Vehicles",{model_name:"Bulk Upload Vehicle"})
      }
      setCorrectData(data?.uploadedData);
      setIncorrectData(data?.errors);
      toast.success(data.message);
      queryClient.invalidateQueries('vehicles');
      // handleClick();
    } catch (error) {
      console.log("Errors", error);
      vehicleBulkUploadEventFunc(ANALYTICS_EVENTS.SYS_BULK_UPLOAD_VEHICLE_ERROR, "Vehicles", {
        model_name: "Bulk Upload Vehicle", errMsg: error?.response?.data?.message
          ? error?.response?.data?.message + JSON.stringify(error?.response?.data?.errors)
          : 'Something went wrong'
      })
      toast.error(
        error?.response?.data?.message
          ? error?.response?.data?.message + JSON.stringify(error?.response?.data?.errors)
          : 'Something went wrong'
      );
      setCorrectData(error?.response?.data?.uploadedData);
      setIncorrectData(error?.response?.data?.errors);
    }
  };

  const handleCorrectDataExport = () => {
    if (correctData?.length > 0) {
      exportExcel(correctData, 'correctData');
    } else {
      toast.error('No data to export');
    }
  };

  const handleIncorrectDataExport = () => {
    if (incorrectData?.length > 0) {
      exportExcel(incorrectData, 'incorrectData');
    } else {
      toast.error('No data to export');
    }
  };

  return (
    <Model
      handleClick={handleClick}
      title={'Bulk Upload'}
      className="max-w-2xl"
    >
      <div className="w-full p-8 flex flex-col justify-start items-start">
        <Button
          onClick={() => window.open(downloadSampleExcelLink, '_blank')}
          bgSecondary
        >
          Download Sample Excel File
        </Button>
        <Input
          type="file"
          className="shadow-sm mt-8"
          name="excelFile"
          onChange={handleFileChange}
        />
        <div className="flex gap-4">
          <Button className="mt-8" onClick={handleClick} bgSecondary>
            Cancel
          </Button>
          <Button className="mt-8" onClick={handleSubmit} bgPrimary>
            Upload
          </Button>
        </div>

        <div className="flex gap-4 mt-8">
          {correctData?.length > 0 && (
            <span
              className="border-b-2 border-green-500 text-green-500 cursor-pointer"
              onClick={handleCorrectDataExport}
            >
              Download Correct Data
            </span>
          )}
          {incorrectData?.length > 0 && (
            <span
              className="  border-b-2 border-red-500 text-red-500 cursor-pointer"
              onClick={handleIncorrectDataExport}
            >
              Download Incorrect Data
            </span>
          )}
        </div>
      </div>
    </Model>
  );
};

export default BulkUpload;
